"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var observer = new MutationObserver(function (mutationsList, observer) {
    var closeButton = document.querySelector(".coveo-facet-modal-close-button");
    var okButton = document.querySelector(".mobile-close-btn");
    var clearAllButton = document.querySelector(".clear-all-btn");
    var coveoClearAllButton = document.querySelector(".coveo-breadcrumb-clear-all.coveo-accessible-button");
    if (closeButton && okButton) {
      okButton.addEventListener("click", function () {
        closeButton.click();
      });
      observer.disconnect();
    }
    if (clearAllButton && coveoClearAllButton) {
      clearAllButton.addEventListener("click", function () {
        coveoClearAllButton.click();
      });
      var queryBoxes = document.querySelectorAll('.magic-box-input input');
      if (queryBoxes) {
        coveoClearAllButton.addEventListener("click", function () {
          queryBoxes.forEach(function (queryBox) {
            queryBox.value = '';
            coveoClearAllButton.click();
          });
        });
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  var overlay = document.createElement("div");
  overlay.className = "filter-overlay";
  document.body.appendChild(overlay);
  var observer2 = new MutationObserver(function () {
    var popup = document.querySelector(".coveo-facet-dropdown-modal-content");
    var closeButton = document.querySelector(".coveo-facet-modal-close-button");
    if (popup) {
      console.log("Popup opened - Showing overlay");
      overlay.style.display = "block";
      if (closeButton) {
        closeButton.addEventListener("click", function () {
          console.log("Popup closed - Hiding overlay");
          overlay.style.display = "none";
        });
      }
    } else {
      overlay.style.display = "none";
    }
  });
  observer2.observe(document.body, {
    childList: true,
    subtree: true
  });
});